import { Flex, Tag, TagLeftIcon } from "@chakra-ui/react";
import { RiArchiveLine } from "react-icons/ri";
import * as AF from "src/types/formTemplate";

type Props = { question: AF.V3.Question };

export const QuestionArchivedTag: React.FC<Props> = ({ question }) => {
  if (!question.isArchived) {
    return null;
  }
  return <ArchivedTag />;
};

export const ArchivedTag: React.FC = () => {
  return (
    <Flex direction="row">
      <Tag size="sm">
        <TagLeftIcon aria-hidden={true} as={RiArchiveLine} />
        Archived
      </Tag>
    </Flex>
  );
};

export function hasArchivedTag(question: AF.V3.Question): boolean {
  return QuestionArchivedTag({ question }) !== null;
}
